import { themeGet } from '@styled-system/theme-get';
import { useTheme } from 'emotion-theming';

export const themeUtil = (theme: any) => (themeKey: string) => themeGet(themeKey)({ theme });

export const useThemeVal = () => {
  const theme = useTheme();
  return themeUtil(theme);
};
